class SearchView {
  _parrentElement = document.querySelector('.search');
  getSearchValue() {
    const query = document.querySelector('.search__field').value;
    this.clear();
    return query;
  }
  addHandelerSearch(handeler) {
    this._parrentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      handeler();
    });
  }

  clear() {
    document.querySelector('.search__field').value = '';
  }
}
export default new SearchView();
